export function matchesAccept(file: File, accept?: string) {
  if (!accept?.trim()) {
    return true
  }

  const fileName = file.name.toLowerCase()
  const mimeType = file.type.toLowerCase()
  return accept
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean)
    .some((rule) => {
      if (rule.startsWith('.')) {
        return fileName.endsWith(rule)
      }
      if (rule.endsWith('/*')) {
        return mimeType.startsWith(rule.slice(0, -1))
      }
      return mimeType === rule
    })
}

export function getClipboardFiles(
  clipboardData?: DataTransfer | null,
  accept?: string,
) {
  if (!clipboardData?.items?.length) {
    return []
  }

  const files: File[] = []
  for (const item of clipboardData.items) {
    if (item.kind !== 'file') {
      continue
    }

    const file = item.getAsFile()
    if (file && matchesAccept(file, accept)) {
      files.push(file)
    }
  }
  return files
}
